import script from "./DueDateCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDateCompo.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&lang=css&external"
import "./DueDateCompo.vue?vue&type=style&index=1&id=27791059&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27791059"]])

export default __exports__